export default __webpack_public_path__ + "static/media/everylive-QRcode-Apple-store.7b5509c3.png";